// extracted by mini-css-extract-plugin
export var markdown = "_uz-0";
export var tableWrapper = "_uz-1";